import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';

import { ProgramaService } from '../programa.service';
import { VagaProgramaService } from '../vaga-programa.service';
import { LocalidadeService } from '../localidade.service';
import { ModalidadeFinanciamentoService } from '../modalidade-financiamento.service';

import { OrigemVaga, ModalidadeFinanciamento } from '../../model/vaga.model';
import { Regiao } from '../../models/response/localidade.model';
import {Programa} from '../../models/response/programa.model';

export interface VagaFormResolverData {
  programas: Programa[];
  origensVaga: OrigemVaga[];
  regioes: Regiao[];
  modalidadesFinanciamento: ModalidadeFinanciamento[];
}

@Injectable({
  providedIn: 'root'
})
export class VagaFormResolver implements Resolve<VagaFormResolverData> {
  private programaService = inject(ProgramaService);
  private vagaService = inject(VagaProgramaService);
  private localidadeService = inject(LocalidadeService);
  private modalidadeFinanciamentoService = inject(ModalidadeFinanciamentoService);

  resolve(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<VagaFormResolverData> {
    return forkJoin({
      programas: this.programaService.getAllActive(),
      origensVaga: this.vagaService.obterOrigensVaga(),
      regioes: this.localidadeService.obterRegioes(),
      modalidadesFinanciamento: this.modalidadeFinanciamentoService.obterTodos()
    });
  }
}
